import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { AppXtender } from '../../models/appXtender';
import { AppXtenderService } from '../../services/app-xtender.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { HttpClient, HttpParams, HttpRequest, HttpHeaders } from '@angular/common/http';
import { FileUploadService } from '../../services/file-upload.service';
import { Router } from '@angular/router';
import { MessageModalComponent } from '../../message-modal/message-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthorizationService } from '../../services/authorization.service';

export class ExpansionOverviewExample {
  panelOpenState = false;
}



@Component({
    selector: 'app-xtender',
    templateUrl: './xtender.component.html',
    styleUrls: ['./xtender.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})


export class XtenderComponent implements OnInit {
  AppXtenderList: AppXtender[] = [];
  AppXtenderList2: AppXtender[] = [];
  selectedAppName: string = "";
  workingApp: AppXtender = new AppXtender();
  modalAction: string = "";
  suppressSaveSuccessful: boolean = false;
  messageText: string = "";
  name!: string;
  workingAppDetails!: string;
  constructor(private AppXtenderService: AppXtenderService,
    private http: HttpClient, public router: Router, private _service: FileUploadService, public dialog: MatDialog,
    private authorizationService: AuthorizationService
  ) {


  }

  displayedColumns_docs: string[] = ['documentDesc', 'dateReceived', 'name', 'tags'];
  displayedColumns_docs2: string[] = ['documentDesc', 'documentSubType', 'dateReceived', 'name', 'tags'];
  /*  displayedColumns_docs: string[] = ['documentType', 'documentSubType','name', 'documentDesc', 'dateReceived', 'documentUser'];*/
  loading = true;
  file: any;
  public files!: string[];
  values = [];
  gc_doc: any;
  gc_doc1: any;
  studentInfo: any;
  dataSource_docs = new MatTableDataSource<any>();
  dataSource_HSCdocs = new MatTableDataSource<any>();
  docsLoading: boolean = true;
  docsUploading: boolean = false;
  adminAuthorized: boolean = false;
  initialLoad: boolean = true;
  appID!: string;
  _url!: string;
  docTypeList: any;
  docSubTypeList: any;
  element2: any;
  panelOpenState: boolean = false;
  Roles: string[] = [];
  filterText: string = '';


  ngOnInit() {

    this.getXtenderDocList();
    this.getHSCXtenderDocList();
    this.getDocumentTypes();
    this.getDocumentSubTypes();
  

    //this.authorizationService.getRoles().then(roles => { alert(roles.join(', ')); });
    //this.authorizationService.getRoles().then(
    //  result => {
    //    this.Roles = result;
    //    this.adminAuthorized = this.Roles.includes("ADMIN");
    //  });

  }

  async upload(event: any, name: string, docType: string, fileDesc: string, authRequired: any, tags: string) {
    console.log(event);
    console.log(name);
    this.workingAppDetails = this.workingApp.docType + "&" + this.workingApp.fileDesc + "&" + this.workingApp.authRequired + "&" + this.workingApp.tags;

    let files = event.target.files;

    let fData: FormData = new FormData;
    if (files.length > 0) {
      this.file = files[0];
    }

    fData.append(this.workingAppDetails, this.file, name + "." + this.file.type.split("/")[1]);
    //debugger;
    const response: any = await this._service.uploadFile(fData).toPromise();
    console.log(response['body'].status);

    if (response['body'].status == 'success') {

      const dialogRef = this.dialog.open(MessageModalComponent, {
        data: {
          modalMsg: '<div class="alert alert-danger">Document Successfully Uploaded!</ div >'
        }
      });

      dialogRef.afterClosed().subscribe(result => {

      });



    }
    else {
      const dialogRef = this.dialog.open(MessageModalComponent, {
        data: {
          modalMsg: '<div class="alert alert-danger">Error Occured while uploading, Please try again!</ div >'
        }
      });


    }

    fData.append(this.workingAppDetails, this.file, name + "." + this.file.type.split("/")[1]);
    debugger;
    this._service.uploadFile(fData).subscribe(
      response => { console.log('works') },
      error => { console.log('failed') }
    )


  }

  handleResponse(response: any) {
    console.log(response);
  }

  handleError(error: string) {
    console.log(error);
  }

  sleep(ms: number) {
    return new Promise(
      resolve => setTimeout(resolve, ms)
    );
  }

  async getXtenderDocList() {
  //  await this.sleep(2000);
    this.gc_doc = await this.http.get('api/AppXtender/GetXtenderDocsList').toPromise();
    this.dataSource_docs = new MatTableDataSource(this.gc_doc);
    this.docsLoading = false;
  }


  async getHSCXtenderDocList() {
    //  await this.sleep(2000);
    this.gc_doc = await this.http.get('api/AppXtender/GetHSCXtenderDocsList').toPromise();
    this.dataSource_HSCdocs = new MatTableDataSource(this.gc_doc);
    this.docsLoading = false;
  }


  async getDocumentTypes() {

    this.http.get('api/AppXtender/GetDocumentTypes').subscribe(
      response => {
        this.docTypeList = response;
      },
      error => {
        console.log(error);
      })
  }

  async getDocumentSubTypes() {

    this.http.get('api/AppXtender/GetDocumentSubTypes').subscribe(
      response => {
        this.docSubTypeList = response;
      },
      error => {
        console.log(error);
      })
  }

  async OpenDoc(element: any) {

    this.element2 = await this.http.get('api/AppXtender/DownloadDocument/' + element).toPromise();
    if (this.element2 != 'Can not view document') {
      var type = this.element2.Extension + '';
      type = type.replace('.', '');
      var binaryString = window.atob(this.element2.FileBytes);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }

      var blob = new Blob([bytes], { type: "application/" + type });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      var fileName = this.element2.Filename;
      link.download = this.element2.Filename;
      link.click();
    }
    else {
      alert(this.element2);
//      this.router.navigate(['/xtender-auth/' + element]);
      this.element2 = await this.http.get('api/AppXtender/DownloadDocumentAuth/' + element).toPromise();
      var type = this.element2.Extension + '';
      type = type.replace('.', '');
      var binaryString = window.atob(this.element2.FileBytes);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }

      var blob = new Blob([bytes], { type: "application/" + type });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      var fileName = this.element2.Filename;
      link.download = this.element2.Filename;
      link.click();

    }
  }


  loadAppXtender() {
    this.http.get('api/AppXtender/GetAppXtenderList').subscribe(
      response => {
        this.gc_doc = response;
      },
      error => {
        console.log(error);
      }
    );
  }

  addAppXtender() {
    this.modalAction = "Add";
    this.workingApp.appId = 0;
    this.workingApp.name = "";
    this.workingApp.docType = "";
    this.workingApp.docSubType = "";
    this.workingApp.fileDesc = "";
    this.workingApp.activityDate = "";
    document.getElementById("openAppXtenderAddModal")!.click();
  }

  save() {
    this.AppXtenderService.save(this.workingApp)
      .subscribe(
        result => {
          this.loadAppXtender();
          this.messageText = "This Xtender record has been successfully saved.";
          if (!this.suppressSaveSuccessful) {
            document.getElementById("openMessageModal")!.click();
          }
        }
      );
  }

  findDetails(app: any) {
    return this.AppXtenderList.filter(x => x.appId === app.appId);
  }

  getDocTypes(app: any) {

    return this.AppXtenderList.filter(
      (app, i, arr) => arr.findIndex(t => t.docType === app.docType) === i);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.filterText = filterValue;

    const predicate = (data: any, filter: string): boolean => {
      const searchable = [
        data.DocumentDesc,
        data.DocumentType,
        data.DocumentSubType,
        data.Tags
      ].filter(v => v).join(' ').toLowerCase();
      return searchable.includes(filter);
    };

    this.dataSource_docs.filterPredicate = predicate;
    this.dataSource_docs.filter = filterValue;

    this.dataSource_HSCdocs.filterPredicate = predicate;
    this.dataSource_HSCdocs.filter = filterValue;
  }

  hasMatchInType(docType: string): boolean {
    if (!this.filterText) return false;
    return this.dataSource_docs.filteredData.some(
      row => row.DocumentType === docType
    );
  }

  hasMatchInHSCType(docType: string): boolean {
    if (!this.filterText) return false;
    return this.dataSource_HSCdocs.filteredData.some(
      row => row.DocumentType === docType
    );
  }

  hasMatchInHSCSubType(docSubType: string): boolean {
    if (!this.filterText) return false;
    return this.dataSource_HSCdocs.filteredData.some(
      row => row.DocumentSubType === docSubType
    );
  }
}

